<template>
  <div v-if="valid">
    <b>{{ name }}</b><span>({{ cin }})</span><br />
    <em>{{ country }}</em>
  </div>
</template>

<script>
import { searchByCinCountry } from '@/services/ElasticHttp'
export default {
  name: "OfferContractor",
  props: ['contractor'],
  computed: {
    cin () {
      return this.contractor.organization ? this.contractor.organization.cin : this.contractor.foreignCin
    },
    name () {
      return this.contractor.organization ? this.contractor.organization.name : ''
    },
    country () {
      return this.contractor.country.text
    },
    valid () {
      return !!this.cin
    }
  },
  async created () {
    if (this.contractor.fetched && (this.contractor.country === 'SK' || this.contractor.country === 'CZ')) {
      const { data } = await this.$elasticHttp.post('prod_rpo_cz_sk_org_search', searchByCinCountry(this.contractor.cin, this.contractor.country))
      if (data.hits.total.value === 1) {
        const organization = data.hits.hits[0]._source
        this.$emit('setContractor', { country: this.contractor.country, organization: organization })
      } else {
        this.$emit('setContractor', { country: this.contractor.country, organization: { cin: this.contractor.cin } })
      }
    }
  }
}
</script>